import { api, ApiClientError } from '@/lib/api/client'
import type {
  ApiRouletteConfig,
  ApiRouletteLog,
  ApiRoulettePage,
  ApiRouletteResult,
  ApiRouletteSlotLog,
  ApiRouletteVisual,
} from './types'

const path = (id: number) => `/api/campaigns/${id}/roulette-api`
export const loadApiRoulette = (id: number) =>
  api.get<ApiRouletteConfig>(`${path(id)}/config`)
export const saveApiRoulette = (id: number, config: ApiRouletteConfig) => {
  const { version, enabled, appearance, slices, allowed_origins, slots } = config
  return api.put<ApiRouletteConfig>(`${path(id)}/config`, {
    version,
    enabled,
    appearance,
    slices,
    allowed_origins,
    slots,
  })
}
export const rotateApiRouletteKey = (id: number) =>
  api.post<{ key: string }>(`${path(id)}/key`, {})
export const loadApiRouletteSlots = (id: number, page: number, signal?: AbortSignal) =>
  api.get<ApiRoulettePage<ApiRouletteSlotLog>>(`${path(id)}/slots?page=${page}`, {
    signal,
  })
export const loadApiRouletteHistory = (
  id: number,
  query: URLSearchParams,
  signal?: AbortSignal
) => api.get<ApiRoulettePage<ApiRouletteLog>>(`${path(id)}/history?${query}`, { signal })

export function apiRouletteError(error: unknown): string {
  if (error instanceof ApiClientError)
    return Object.values(error.errors ?? {}).flat()[0] ?? error.message
  return error instanceof Error ? error.message : 'Não foi possível concluir a operação.'
}

/** External renderer: explicit capability, no ambient administrative or donor cookies. */
async function externalRequest<T>(
  base: string,
  id: number,
  action: string,
  token?: string,
  signal?: AbortSignal
): Promise<T> {
  const response = await fetch(
    `${base.replace(/\/+$/, '')}/api/roulette-api/${id}/${action}`,
    {
      method: token ? 'POST' : 'GET',
      credentials: 'omit',
      signal,
      headers: {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  )
  const body = (await response.json()) as { data?: T; message?: string }
  if (!response.ok || body.data === undefined)
    throw new Error(body.message ?? 'Não foi possível acessar a roleta.')
  return body.data
}

export const fetchExternalRoulette = (base: string, id: number, signal?: AbortSignal) =>
  externalRequest<ApiRouletteVisual>(base, id, 'config', undefined, signal)
export const spinExternalRoulette = (base: string, id: number, token: string) =>
  externalRequest<ApiRouletteResult>(base, id, 'spin', token)
